"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionWithDescription = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var CsButtonPrimary_1 = __importDefault(require("../Buttons/CsButtonPrimary"));
var ActionWithDescription_styles_1 = require("./ActionWithDescription.styles");
exports.ActionWithDescription = function (_a) {
    var heading = _a.heading, description = _a.description, buttonText = _a.buttonText, onClick = _a.onClick, icon = _a.icon;
    var shownIcon = icon ? react_1.default.createElement(icon, { style: { marginRight: 5 } }) : react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Box, { color: "secondary.main" },
            react_1.default.createElement(Typography_1.default, { variant: "h4" }, heading)),
        react_1.default.createElement("div", { style: ActionWithDescription_styles_1.descriptionContainer },
            react_1.default.createElement(Typography_1.default, { variant: "body1" }, description)),
        (buttonText || icon) && onClick && (react_1.default.createElement("div", { style: ActionWithDescription_styles_1.buttonContainer },
            react_1.default.createElement(CsButtonPrimary_1.default, { onClick: onClick, label: buttonText, style: { paddingLeft: 50, paddingRight: 50 } }, shownIcon)))));
};
exports.default = exports.ActionWithDescription;
//# sourceMappingURL=ActionWithDescription.js.map